import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-cube-01',
  standalone: true,
  templateUrl: './rt-icon-cube-01.component.html',
  styleUrls: ['./rt-icon-cube-01.component.scss']
})
export class RtIconCube01Component {
  @Input() width: number | string = 15;
  @Input() height: number | string = 17;
}
